import React from 'react';
import { ResponsiveGrid } from '@alifd/next';
import ResetPasswordVerifyBlock from './components/ResetPasswordVerifyBlock';

const { Cell } = ResponsiveGrid;

const ResetPasswordVerify = () => (
  <ResponsiveGrid gap={20}>
    <Cell colSpan={12}>
      <ResetPasswordVerifyBlock />
    </Cell>
  </ResponsiveGrid>
);

export default ResetPasswordVerify;
